<template>
  <div class="container-custom">
    <!-- breadcrumbs -->
    <div class="breadscrumbs">
      <a class="breadscrumbs-item active">Support FAQ</a>
    </div>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>Support FAQ</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="toSupportFaqCreate">
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增FAQ</span>
      </button>
    </div>
    <!-- Table -->
    <SupportFaqTable></SupportFaqTable>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import SupportFaqTable from '@/views/H-2__SupportFaq/c/SupportFaqTable.vue';

export default {
  components: {
    SupportFaqTable,
  },
  created() {
    this.clear();
    this.getFaqs();
  },
  methods: {
    ...mapActions('supportFaq', {
      getFaqs: 'find',
      clear: 'clear',
    }),
    toSupportFaqCreate() {
      this.$router.push({ path: '/support-faq/create' });
    },
  },
};
</script>

<style></style>
